import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import FormattedAmount from './FormattedAmount';
import FormattedPriceChangePct from './FormattedPriceChangePct';
import { isWeb } from '../../../constants';
export const StockSummaryCard = React.memo(({ name, assetId, iconUrl, onPress, currentPrice, sharePriceChangePct = 0 }) => {
    const styles = useStyles(styleSet);
    const symbol = useAppSelector((state) => state.invest.caches[assetId]?.symbol);
    return (<TouchableBounce style={[styles.container, styles.touchable]} onPress={onPress} hoverStyle={styles.hover}>
        <View style={styles.container}>
          <Logo R44 uri={iconUrl} resizeMode="contain"/>
          <Spacer h={16}/>
          <Text Text-16 numberOfLines={1}>
            {name || ' '}
          </Text>
          <Text TextThin-14 numberOfLines={1} Gray>
            {symbol ? `$${symbol}` : ' '}
          </Text>
          <Spacer h={8}/>
          <FormattedAmount amount={currentPrice}/>
          <Spacer h={4}/>
          <FormattedPriceChangePct priceChangePct={sharePriceChangePct}/>
        </View>
      </TouchableBounce>);
});
StockSummaryCard.displayName = 'StockSummaryCard';
export const SecclAssetSummaryCard = React.memo(({ name, iconUrl, onPress }) => {
    const styles = useStyles(styleSet);
    const { contentWidth } = useAppFrameDimensions(isWeb);
    return (<TouchableBounce style={[{ width: Math.min(contentWidth / 3, SECCL_CARD_WIDTH) }, styles.secclContainer, styles.touchable]} onPress={onPress} hoverStyle={styles.hover}>
      <View style={styles.secclInnerContainer}>
        <Logo R44 uri={iconUrl} resizeMode="contain"/>
        <Spacer h={16}/>
        <Text Text-16 numberOfLines={2} centered>
          {name || ' '}
        </Text>
      </View>
    </TouchableBounce>);
});
SecclAssetSummaryCard.displayName = 'SecclAssetSummaryCard';
const SPACING_BETWEEN_ITEMS = 8;
const BORDER_RADIUS = 12;
export const CARD_WIDTH = rem(204);
export const SECCL_CARD_WIDTH = rem(200);
const styleSet = createStyleSheets((colors) => ({
    hover: {
        opacity: 0.8,
    },
    touchable: {
        marginHorizontal: rem(SPACING_BETWEEN_ITEMS / 2),
        padding: 0,
    },
    container: {
        padding: rem(16),
        width: CARD_WIDTH,
        borderRadius: rem(BORDER_RADIUS),
        backgroundColor: colors.cards.onDark,
    },
    secclContainer: {
        borderRadius: rem(BORDER_RADIUS),
        backgroundColor: colors.background.light,
    },
    secclInnerContainer: {
        flex: 1,
        padding: rem(16),
        alignItems: 'center',
        borderRadius: rem(BORDER_RADIUS),
        backgroundColor: colors.cards.onDark,
    },
}));
